'use strict';

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _svg4everybody = require('svg4everybody');

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
    (0, _svg4everybody2.default)();
});

/**
 * Simple script that handles the search form.
 */
/**
 * Initiate svg4everybody
 */
document.addEventListener('DOMContentLoaded', function () {
    var _loop = function _loop(form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            // Build the hash.
            var hash = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(form.querySelectorAll('input, select')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var input = _step2.value;

                    hash.push(input.name + '=' + input.value);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            window.location.href = form.getAttribute('action') + '#' + hash.join('&');

            if (form.getAttribute('data-add-hash-on-submit') === 'reload') {
                window.location.reload();
            }
        });
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('[data-add-hash-on-submit]')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var form = _step.value;

            _loop(form);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {

        for (var _iterator3 = (0, _getIterator3.default)(document.querySelectorAll('[data-fill-from-hash]')), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var input = _step3.value;

            var key = input.getAttribute('data-fill-from-hash') || input.name;
            var hash = window.location.hash.replace('#', '').split('&').reduce(function (carry, element) {
                var _element$split = element.split('='),
                    _element$split2 = (0, _slicedToArray3.default)(_element$split, 2),
                    key = _element$split2[0],
                    value = _element$split2[1];

                carry[key] = decodeURIComponent(value);
                return carry;
            }, {});

            if (hash[key]) {
                input.value = hash[key];
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
});